export const SET_MODAL = 'SET_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CLOSE_OVERLAYS = 'CLOSE_OVERLAYS'
